import posthog from 'posthog-js'

export const initPostHog = () => {
  const hash = window.location.hash.slice(1)
  const params = new URLSearchParams(hash)
  const distinctId = params.get('distinct_id') || undefined
  const sessionId = params.get('session_id') || undefined

  posthog.init(process.env.REACT_APP_POSTHOG_KEY!, {
    api_host: process.env.REACT_APP_POSTHOG_HOST,
    capture_pageview: false,
    bootstrap: {
      ...(distinctId && { distinctID: distinctId }),
      ...(sessionId && { sessionID: sessionId }),
    },
  })
}

export const appendPostHogParams = (url: string): string => {
  const distinctId = posthog.get_distinct_id()
  const sessionId = posthog.get_session_id()
  if (!distinctId && !sessionId) return url
  return `${url}#distinct_id=${distinctId}&session_id=${sessionId}`
}

// Matches lead-app-form-website's `FormUtils.cleansePhone` (digits only) so the
// `phone` person property has one shape across both apps. This app stores phone
// numbers E.164-style (+15551234567) while the lead app collects raw 10-digit
// input, so the US country code is dropped here.
const cleansePhone = (phone: string): string => {
  const digits = phone.replace(/[^0-9]/g, '')
  return digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits
}

// Call whenever the user provides an email and/or phone number. Mirrors
// lead-app-form-website/src/component/forms/navigation.jsx: identify against the
// current distinct ID so the anonymous session is kept, and attach the contact
// details as person properties.
export const identifyUser = ({
  email,
  phone,
}: {
  email?: string | null
  phone?: string | null
}) => {
  if (!email && !phone) return

  posthog.identify(posthog.get_distinct_id(), {
    ...(email && { email }),
    ...(phone && { phone: cleansePhone(phone) }),
  })
}
